module.exports = __webpack_public_path__ + "img/total-dealer-apps.2f94e2b9.svg";